import axios from "axios";

import Api from "../Constants/Api"; 

// base url axios
axios.defaults.baseURL = Api.PUBLIC_API;

axios.interceptors.request.use(async (config) => {
    const token = sessionStorage.getItem("Access_Token");
    if (config?._addToken !== false) {
        if (token) {
            config.headers.Authorization = "Bearer " + token;
            return config;
        } else {
            return Promise.resolve(config);
        }
    } else {
        return config;
    }
}, error => Promise.reject(error)
);
export {axios};